import script from "./Blockquotes.vue?vue&type=script&setup=true&lang=ts"
export * from "./Blockquotes.vue?vue&type=script&setup=true&lang=ts"

import "./Blockquotes.vue?vue&type=style&index=0&id=a5e82450&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5e82450"]])

export default __exports__